import { api } from "./http";

export const storageApi = {
    getUrlImage: (resourceId, resourceType) => api.get(`/api/Storage/resource?resourceId=${resourceId}&resourceType=${resourceType}`),
    uploadImage: (resourceId, resourceType,data) => api.post(`/api/Storage/image?resourceId=${resourceId}&resourceType=${resourceType}`, data),
    uploadTemptFile: (data) => api.post(`/api/Storage/tempt/upload`, data)
}